<template>
    <div style="min-width: 1800px">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">ETP业务系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>管理费统计</el-breadcrumb-item>
        </el-breadcrumb>

        <el-row :gutter="20" style="margin-top: 20px">
            <el-col :span="12">
                <el-select v-model="type" placeholder="请选择时间类型" @change="getManagementTrend"
                           style="float: right;margin-right: 90px;z-index: 9999999">
                    <el-option label="日" value="DAY"></el-option>
                    <el-option label="月" value="MONTH"></el-option>
                </el-select>
                <div id="manage-free" style="width: 100%;height: 350px"></div>
            </el-col>
            <el-col :span="8">
                <div id="coin-manage-free" style="width: 100%;height: 350px"></div>
            </el-col>
        </el-row>

        <div>
            <h1 style="font-size: 18px;display: inline-block">管理费列表</h1>
            <span style="font-size: 14px;padding-left: 20px;padding-right: 10px">时间范围</span>
            <el-date-picker v-model="date" type="datetimerange" value-format="timestamp" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-button type="primary" @click="searchData">查 询</el-button>

            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 10px"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column label="序号">
                    <el-table-column label="合计" type="index" :index="indexMethod" width="100px"></el-table-column>
                </el-table-column>
                <el-table-column label="交易币种">
                    <el-table-column label="全部" prop="coin"></el-table-column>
                </el-table-column>
                <el-table-column label="管理费（USDT）">
                    <el-table-column :label="sumManagement.managementCost+''" prop="managementCost"></el-table-column>
                </el-table-column>
                <el-table-column label="3L管理费（USDT）">
                    <el-table-column :label="sumManagement.managementCost3L+''"
                                     prop="managementCost3L"></el-table-column>
                </el-table-column>
                <el-table-column label="3S管理费（USDT）">
                    <el-table-column :label="sumManagement.managementCost3S+''"
                                     prop="managementCost3S"></el-table-column>
                </el-table-column>
                <el-table-column label="5L管理费（USDT）">
                    <el-table-column :label="sumManagement.managementCost5L+''"
                                     prop="managementCost5L"></el-table-column>
                </el-table-column>
                <el-table-column label="5S管理费（USDT）">
                    <el-table-column :label="sumManagement.managementCost5S+''"
                                     prop="managementCost5S"></el-table-column>
                </el-table-column>
            </el-table>

            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParam.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParam.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import './store';
    import api from './api';
    import moment from 'moment';

    export default {
        name: 'ManageFee',
        data() {
            return {
                type: "DAY",
                date: [],
                dataList: [],
                total: 0,
                sumManagement: {},
                manageFreeOption: null,
                manageFreeChart: null,
                coinManageFreeOption: null,
                coinManageFreeChart: null,
                queryParam: {endTime: "", startTime: "", size: 10, page: 1},
                FORMAT_DAY: 'YYYY-MM-DD',
                FORMAT_MONTH: 'YYYY-MM'
            };
        },
        methods: {
            moment(value) {
                if (!value) return '';
                return moment(value).format(this.type == "DAY" ? this.FORMAT_DAY : this.FORMAT_MONTH);
            },
            indexMethod(index) {
                return index + 1;
            },
            searchData() {
                if (this.date) {
                    this.queryParam.startTime = this.date[0];
                    this.queryParam.endTime = this.date[1];
                } else {
                    this.queryParam = {endTime: "", startTime: ""};
                }
                this.getManagementList();
            },
            getManagementList() {
                api.getManagementList(this.queryParam).then(({data}) => {
                    this.dataList = data.managementListVOList.records;
                    this.total = data.managementListVOList.total;
                    this.sumManagement = data.sumManagementListVO;
                });
            },
            getManagementTrend() {
                api.getManagementTrend({dateType: this.type}).then(({data}) => {
                    this.initManageFree(data);
                });
            },
            getManagementProportion() {
                api.getManagementProportion().then(({data}) => {
                    this.initCoinManageFree(data);
                });
            },
            initManageFree(data) {
                let _othis = this;
                let manageFree = document.getElementById('manage-free');
                this.manageFreeChart = this.$echarts.init(manageFree);
                this.manageFreeOption = {
                    title: {
                        text: '管理费走势'
                    },
                    tooltip: {
                        show: true,
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        },
                        formatter: function (params) {
                            return "时间：" + _othis.moment(params[0].axisValue) + "<br>" + "管理费：" + params[0].value + " USDT";
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [],
                        type: 'line'
                    }]
                };

                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        this.manageFreeOption.xAxis.data.push(this.moment(data[i].time));
                        this.manageFreeOption.series[0].data.push(data[i].amount);
                    }
                }

                this.manageFreeOption && this.manageFreeChart.setOption(this.manageFreeOption);
            },
            initCoinManageFree(data) {
                let coinManageFree = document.getElementById('coin-manage-free');
                this.coinManageFreeChart = this.$echarts.init(coinManageFree);
                this.coinManageFreeOption = {
                    title: {
                        text: '各币种管理费'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: function (params) {
                            return params.name + " " + params.percent + "%";
                        }
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'right',
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: '80%',
                            data: [],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 2,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };

                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        this.coinManageFreeOption.series[0].data.push({name: data[i].coin, value: data[i].rate});
                    }
                }

                this.coinManageFreeOption && this.coinManageFreeChart.setOption(this.coinManageFreeOption);
            },
            handleSizeChange(val) {
                this.queryParam.size = val;
                this.getManagementList();
            },
            handleCurrentChange(val) {
                this.queryParam.page = val;
                this.getManagementList();
            },
        },
        created() {

        },
        mounted() {
            this.getManagementList();
            this.getManagementTrend();
            this.getManagementProportion();
        }
    };
</script>

<style lang="less" scoped></style>

